// extracted by mini-css-extract-plugin
export default {"add_favorite":"addFavoriteButton_add_favorite__BmiS6"};